import { Box, Tooltip } from "@mui/material";

import AddCircleOutlineOutlinedIcon from "@mui/icons-material/AddCircleOutlineOutlined";
import AlternateEmailOutlinedIcon from "@mui/icons-material/AlternateEmailOutlined";
import BorderColor from "@mui/icons-material/BorderColor";
import ChatOutlinedIcon from "@mui/icons-material/ChatOutlined";
import CreateNewFolderOutlinedIcon from "@mui/icons-material/CreateNewFolderOutlined";
import DeleteIcon from "@mui/icons-material/Delete";
import EditDocumentIcon from "@mui/icons-material/EditNote";
import LibraryBooksIcon from "@mui/icons-material/LibraryBooks";
import LogoutOutlinedIcon from "@mui/icons-material/LogoutOutlined";
import ModeOutlinedIcon from "@mui/icons-material/ModeOutlined";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import Print from "@mui/icons-material/Print";
import ReplayOutlinedIcon from "@mui/icons-material/ReplayOutlined";
import StarOutlineOutlinedIcon from "@mui/icons-material/StarOutlineOutlined";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import IconButton from "@mui/material/IconButton";
import Stack from "@mui/material/Stack";
import { useNavigate } from "react-router-dom";
import configUrls from "../../../config/configUrls";
import { Documento, ISdocumento } from "../../../types/processo/Documento";
import { ButtonPressDarCienciaDocumento } from "../documentoDarCiencia/buttonPressDarCienciaDocumento";
import { useEffect, useState } from "react";
import PrintFullContentButton from "../../../components/formControls/PrintFullContentButton";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../../app/store";
import { setNullProcessoSelecioadoSlice } from "../../iniciarProcesso/processoSelecionadoSlice";

type Props = {
  documento: string;
  documentoData?: Documento; // Dados do documento, se necessário
};

export const DocumentoInternoViewMenu = ({
  documento,
  documentoData,
}: Props) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const removeProcessoSelecionado = () => {
    dispatch(setNullProcessoSelecioadoSlice());
  };

  return (
    <>
      <Box
        mt={0}
        p={0}
        sx={{
          backgroundColor: "#f7f7f7",
          padding: "16px",
          display: "flex",
          justifyContent: "space-between",
          width: "100%",
          border: "1px solid #000",
          borderRadius: "8px",
          overflowX: "auto",
        }}
      >
        <Box
          display="flex"
          flexDirection="row"
          flexWrap="wrap"
          justifyContent="flex-start"
        >
          <Stack direction="row" spacing={0} flexWrap="wrap">
            <Tooltip title="Adicionar Documento">
              <IconButton
                color="secondary"
                size="large"
                onClick={() => {
                  navigate(configUrls.PROCESSO_GERAR_DOCUMENTO_CREATE_RT);
                }}
              >
                <AddCircleOutlineOutlinedIcon />
              </IconButton>
            </Tooltip>

            <Tooltip title="Consultar/Alterar dados do cadastro do documento">
              <IconButton
                color="secondary"
                size="large"
                onClick={() => {
                  navigate(
                    `${configUrls.PROCESSO_GERAR_DOCUMENTO_EDIT_LK}${documento}`
                  );
                }}
              >
                <ModeOutlinedIcon />
              </IconButton>
            </Tooltip>

            <Tooltip title="Acompanhamento Especial">
              <IconButton
                color="secondary"
                size="large"
                onClick={() => {
                  navigate(configUrls.PROCESSO_ACOMPANHAMENTO_LIST_RT);
                }}
              >
                <VisibilityOutlinedIcon />
              </IconButton>
            </Tooltip>

            <Tooltip title="Dar Ciência Documento" arrow>
              <div>
                <ButtonPressDarCienciaDocumento documentoId={documento} />
              </div>
            </Tooltip>

            <Tooltip title="Editar Conteúdo">
              <IconButton
                color="secondary"
                size="large"
                onClick={() => {
                  navigate(`${configUrls.DOCUMENTO_EDITAR_LK}${documento}`);
                }}
              >
                <EditDocumentIcon />
              </IconButton>
            </Tooltip>

            <Tooltip title="Atualizar Andamento">
              <IconButton
                color="secondary"
                size="large"
                onClick={() => {
                  navigate(
                    `${configUrls.DOCUMENTO_HISTORICO_LIST_LINK}${documento}`
                  );
                }}
              >
                <ReplayOutlinedIcon />
              </IconButton>
            </Tooltip>

            <Tooltip title="Adicionar aos Favoritos">
              <IconButton
                color="secondary"
                size="large"
                onClick={() => {
                  navigate(
                    `${configUrls.DOCUMENTO_FAVORITO_LIST_LINK}${documento}`
                  );
                }}
              >
                <StarOutlineOutlinedIcon />
              </IconButton>
            </Tooltip>

            <Tooltip title="Enviar por e-mail">
              <IconButton
                color="secondary"
                size="large"
                onClick={() => {
                  navigate(
                    `${configUrls.DOCUMENTO_EMAIL_LIST_LINK}${documento}`
                  );
                }}
              >
                <AlternateEmailOutlinedIcon />
              </IconButton>
            </Tooltip>

            <Tooltip title="Assinar eletronicamente ">
              <IconButton color="secondary" size="large"
               onClick={() => {
                  navigate(
                    `${configUrls.DOCUMENTO_ASSINAR_LIST_LINK}${documento}`
                  );
                }}
              >
                <BorderColor />
              </IconButton>
            </Tooltip>

            <Tooltip title="Adicionar um bloco">
              <IconButton
                color="secondary"
                size="large"
                onClick={() => {
                  navigate(configUrls.PROCESSO_BLOCO_LIST_RT);
                }}
              >
                <CreateNewFolderOutlinedIcon />
              </IconButton>
            </Tooltip>

            <Tooltip title="Comentários">
              <IconButton
                color="secondary"
                size="large"
                onClick={() => {
                  navigate(
                    `${configUrls.DOCUMENTO_COMENTARIO_LIST_LINK}${documento}`
                  );
                }}
              >
                <ChatOutlinedIcon />
              </IconButton>
            </Tooltip>

            <Tooltip title="Versões do Documento">
              <IconButton
                color="secondary"
                size="large"
                onClick={() => {
                  navigate(
                    `${configUrls.DOCUMENTO_VERSAO_LIST_LINK}${documento}`
                  );
                }}
              >
                <LibraryBooksIcon />
              </IconButton>
            </Tooltip>

            <Tooltip title="Imprimir web">
              <div>
                <PrintFullContentButton
                  documento={documentoData ? documentoData : ISdocumento}
                  conteudoTexto={documentoData?.conteudo ?? ""} // Conteúdo do documento
                />
              </div>
            </Tooltip>

            <Tooltip title="Gerar PDF">
              <IconButton color="secondary" size="large">
                <PictureAsPdfIcon />
              </IconButton>
            </Tooltip>

            <Tooltip title="Voltar para Lista de Processos">
              <IconButton
                color="secondary"
                size="large"
                onClick={() => {
                  dispatch(setNullProcessoSelecioadoSlice());
                  window.location.href = configUrls.PROCESSO_LIST_RT; // Força refresh
                  window.location.reload();
                }}
              >
                <LogoutOutlinedIcon />
              </IconButton>
            </Tooltip>

            <Tooltip title="Deletar">
              <IconButton aria-label="delete" color="secondary" size="large">
                <DeleteIcon />
              </IconButton>
            </Tooltip>
          </Stack>
        </Box>
      </Box>
    </>
  );
};
